import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddSource, UpdateSource } from './source';

@Injectable({
  providedIn: 'root',
})
export class SourceService {
  private basePath = environment.interop.basePath;
  private getSurseDTURL =
    this.basePath +
    environment.interop.platform.nomenclatoare.source.getSurseDT;
  private token!: string;
  private httpOptions: any;
  private storeSurseURL =
    this.basePath +
    environment.interop.platform.nomenclatoare.source.storeSurse;
  private updateSurseURL =
    this.basePath +
    environment.interop.platform.nomenclatoare.source.updateSurse;
  private deleteSurseURL =
    this.basePath +
    environment.interop.platform.nomenclatoare.source.deleteSurse;

  constructor(private http: HttpClient) {}

  getSurse() {
    return this.http.get(this.getSurseDTURL, this.httpOptions);
  }

  addSurse(source: AddSource) {
    return this.http.post(this.storeSurseURL, source, this.httpOptions);
  }

  updateSurse(source: UpdateSource) {
    return this.http.put(this.updateSurseURL, source, this.httpOptions);
  }

  deleteSurse(id: number) {
    return this.http.delete(this.deleteSurseURL + id);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
